<template>
  <div>
    <v-text-field
      label="Mağaza Adı"
      v-model="localData.companyName"
      @input="emitUpdate"
    />
    <v-textarea
      label="Adres"
      v-model="localData.companyAddress"
      maxlength="255"
      counter="255"
      rows="1"
      auto-grow
      required
      @input="emitUpdate"
    ></v-textarea>
    <div style="margin-top: 16px; color: darkslategray;">Anlaşma Tipi</div>
    <v-radio-group
      v-model="localData.subscriptionType"
      row
      style="margin-left: 8px;"
    >
      <v-radio value="BASIC" class="custom_radio">
        <template v-slot:label>
          <v-img
            :src="require('../../assets/icons/basic-package.svg')"
            contain
            class="mr-2"
          />
          <div>
            Basic Paket
          </div>
        </template>
      </v-radio>
      <v-radio value="PLUS" class="custom_radio">
        <template v-slot:label>
          <v-img
            :src="require('../../assets/icons/plus-package.svg')"
            contain
            class="mr-2"
          />
          <div>
            Plus Paket
          </div>
        </template>
      </v-radio>
    </v-radio-group>

    <div style="margin-top: 16px; color: darkslategray;">Bardak Boyları</div>
    <div class="custom-checkboxes" style="margin-top: 8px;">
      <div
        v-for="size in coffeeSizes"
        :key="size.type"
        @click="onSelectCoffeeSize(size.type)"
        :class="[
          {
            'custom-checkbox-active':
              localData.coffeeSizeType &&
              localData.coffeeSizeType.indexOf(size.type) !== -1,
          },
          'custom-checkbox',
        ]"
      >
        <div>
          <v-img
            :src="require('../../assets/icons/cup.svg')"
            contain
            class="mr-2"
            :style="{ height: size.imgHeight }"
          />
          <div>
            {{ size.text }}
          </div>
        </div>
      </div>
    </div>
    <!-- <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      En az bir adet bardak boyu seçmelisiniz!
    </small> -->

    <div style="margin-top: 16px; color: darkslategray;">Süt Seçenekleri</div>
    <div class="custom-checkboxes" style="margin-top: 8px;">
      <v-checkbox
        v-for="milk in milkTypes"
        :key="milk.type"
        
        color="#12B76A"
        :label="milk.text"
        v-model="localData.milkType"
        :value="milk.type"
      ></v-checkbox>
    </div>

    <!-- <small style="color: #98a2b3; font-size: 11px; margin-top: -5px;">
      En az bir adet süt seçeneği seçmelisiniz!
    </small> -->
  </div>
</template>

<script>
export default {
  name: 'StoreInfoForm',
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      localData: { ...this.formData },
      coffeeSizes: [
        {
          type: 'Small',
          text: 'Küçük',
          imgHeight: '48px',
        },
        {
          type: 'Medium',
          text: 'Orta',
          imgHeight: '64px',
        },
        {
          type: 'Large',
          text: 'Büyük',
          imgHeight: '80px',
        },
      ],
      milkTypes: [
        {
          type: 'LowFat',
          text: 'Az Yağlı',
        },
        {
          type: 'LactoseFree',
          text: 'Laktozsuz',
        },
        {
          type: 'WithoutMilk',
          text: 'Sütsüz',
        },
        {
          type: 'FullFat',
          text: 'Tam Yağlı',
        },
      ],
    }
  },
  methods: {
    emitUpdate() {
      this.$emit('update-form-data', 'storeInfo', this.localData)
    },
    onSelectCoffeeSize(size) {
      let oldCoffeeSizes = this.localData.coffeeSizeType || []
      let newCoffeeSizes = oldCoffeeSizes.includes(size)
        ? oldCoffeeSizes.filter((x) => x !== size)
        : [...oldCoffeeSizes, size]

      this.localData.coffeeSizeType = newCoffeeSizes
      this.$emit('update-form-data', 'storeInfo', this.localData)
    },
    // onSelectMilkType(milkType) {
    //   let oldMilkTypes = this.localData.milkType || []
    //   let newMilkTypes = oldMilkTypes.includes(milkType)
    //     ? oldMilkTypes.filter((x) => x !== milkType)
    //     : [...oldMilkTypes, milkType]
        
    //   this.localData.milkType = newMilkTypes
    //   console.log(this.localData)
    //   this.$emit('update-form-data', 'storeInfo', this.localData)
    // },
  },
  watch: {
    'localData.milkType'() {
      this.$emit('update-form-data', 'storeInfo', this.localData);
    }
  }
}
</script>
<style>
.custom-checkboxes {
  display: flex;
  gap: 20px;
}
.custom-checkbox {
  height: 150px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.custom-checkbox-active {
  border: 1px solid #12b76a;
}

.custom_radio {
  display: flex;
  flex-direction: row-reverse;
  padding: 8px 12px;
  border: 1px solid #e4e7ec;
  border-radius: 12px;
  gap: 12px;
}

.v-application--is-ltr .v-input--selection-controls__input {
  margin-right: 0 !important;
}
</style>
